import React, { useState } from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../layout/layout";
import { toast } from "react-toastify";
import { changePassword } from "../../redux/slices/userSlice"; // Gọi API đổi mật khẩu
import { jwtDecode } from "jwt-decode";
const ChangePassword = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { userInfo, loading } = useSelector((state) => state.user);
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  // Regex kiểm tra mật khẩu mạnh (giống backend)
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // Xử lý thay đổi input
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Xóa lỗi khi user nhập lại
  };

  // Kiểm tra dữ liệu trước khi gửi request
  const validate = () => {
    let newErrors = {};
    if (!formData.currentPassword && userInfo.loginBy.includes("Normal"))
      newErrors.currentPassword = "Vui lòng nhập mật khẩu cũ.";
    if (!formData.newPassword) {
      newErrors.newPassword = "Mật khẩu không được để trống.";
    } else if (!passwordRegex.test(formData.newPassword)) {
      newErrors.newPassword =
        "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.";
    }
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Vui lòng xác nhận mật khẩu.";
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = "Mật khẩu mới không khớp.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Trả về true nếu không có lỗi
  };

  // Gửi request đổi mật khẩu
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const decoded = jwtDecode(user);
      const userId = decoded["sub"];
      const response = await dispatch(
        changePassword({ userId, changePasswordDTO: formData })
      ).unwrap();
      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      toast.success(response.message); // Hiển thị thông báo thành công
    } catch (error) {
      toast.error(error.message || "Đổi mật khẩu thất bại!");
    }
  };

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row">
            <Sidebar page="my-profile" />
            <div className="col-xl-9 col-lg-8 ">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Cài đặt</h6>
                </div>
                <div className="card-body pb-3">
                  <div className="settings-link d-flex align-items-center flex-wrap">
                    <Link to="/update-user">
                      <i className="isax isax-user-octagon me-2"></i>Chỉnh sửa
                      thông tin
                    </Link>
                    <Link to="/change-password" className="active ps-3">
                      <i className="isax isax-shield-tick me-2"></i>Bảo mật
                    </Link>
                  </div>

                  <div className="card-body " style={{ width: "50%" }}>
                    <h6 className="fs-16 mb-3">Thay đổi mật khẩu</h6>
                    {userInfo.loginBy === "Normal" ? (
                      <div className="mb-3">
                        <label className="form-label">
                          Mật khẩu hiện tại{" "}
                          <span className="text-primary">*</span>
                        </label>
                        <div class="input-icon">
                          {!errors.currentPassword ? (
                            <span class="input-icon-addon">
                              <i class="isax isax-lock"></i>
                            </span>
                          ) : (
                            ""
                          )}
                          <input
                            type={showCurrentPassword ? "text" : "password"}
                            name="currentPassword"
                            className={`form-control ${
                              errors.currentPassword ? "is-invalid" : ""
                            }`}
                            value={formData.currentPassword}
                            onChange={handleChange}
                          />
                          <span
                            className="input-icon-addon toggle-password"
                            onClick={() =>
                              setShowCurrentPassword(!showCurrentPassword)
                            }
                            style={{ cursor: "pointer" }} // Để icon có thể click
                          >
                            <i
                              className={
                                showCurrentPassword
                                  ? "isax isax-eye"
                                  : "isax isax-eye-slash"
                              }
                            ></i>
                          </span>
                        </div>
                        {errors.currentPassword && (
                          <div className="text-danger">
                            {errors.currentPassword}
                          </div>
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mb-3">
                      <label className="form-label">
                        Mật khẩu mới <span className="text-primary">*</span>
                      </label>
                      <div class="input-icon">
                        {!errors.newPassword ? (
                          <span class="input-icon-addon">
                            <i class="isax isax-lock"></i>
                          </span>
                        ) : (
                          ""
                        )}
                        <input
                          type={showPassword ? "text" : "password"}
                          name="newPassword"
                          className={`form-control ${
                            errors.newPassword ? "is-invalid" : ""
                          }`}
                          value={formData.newPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="input-icon-addon toggle-password"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }} // Để icon có thể click
                        >
                          <i
                            className={
                              showPassword
                                ? "isax isax-eye"
                                : "isax isax-eye-slash"
                            }
                          ></i>
                        </span>
                      </div>
                      {errors.newPassword && (
                        <div className="text-danger">{errors.newPassword}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Xác nhận mật khẩu{" "}
                        <span className="text-primary">*</span>
                      </label>
                      <div class="input-icon">
                        {!errors.confirmPassword ? (
                          <span class="input-icon-addon">
                            <i class="isax isax-lock"></i>
                          </span>
                        ) : (
                          ""
                        )}
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          className={`form-control ${
                            errors.confirmPassword ? "is-invalid" : ""
                          }`}
                          value={formData.confirmPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="input-icon-addon toggle-password"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          style={{ cursor: "pointer" }} // Để icon có thể click
                        >
                          <i
                            className={
                              showConfirmPassword
                                ? "isax isax-eye"
                                : "isax isax-eye-slash"
                            }
                          ></i>
                        </span>
                      </div>
                      {errors.confirmPassword && (
                        <div className="text-danger">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </div>

                    <div className="modal-footer">
                      <Link
                        to="/my-profile"
                        type="button"
                        className="btn btn-light btn-md me-2"
                        data-bs-dismiss="modal"
                      >
                        Hủy
                      </Link>
                      <button
                        type="submit"
                        className="btn btn-primary btn-md"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                        ) : (
                          <>Cập nhập</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ChangePassword;
